import { api, API } from "./api";

// Conexão WebSocket com ticket de uso único + reconexão com backoff.
// onEvent recebe { tipo, dados, em }. Retorna função de encerramento.
export function connectWS(onEvent) {
  let ws = null;
  let closed = false;
  let retry = 0;
  let timer = null;

  const open = async () => {
    try {
      const r = await api.post("/ws/ticket");
      const url = API.replace(/^http/, "ws") + "/ws?ticket=" + r.data.ticket;
      ws = new WebSocket(url);
      ws.onopen = () => { retry = 0; };
      ws.onmessage = (ev) => { try { onEvent(JSON.parse(ev.data)); } catch {} };
      ws.onclose = () => { if (!closed) timer = setTimeout(open, Math.min(15000, 1000 * 2 ** retry++)); };
      ws.onerror = () => { try { ws.close(); } catch {} };
    } catch {
      if (!closed) timer = setTimeout(open, Math.min(15000, 1000 * 2 ** retry++));
    }
  };
  open();

  return () => {
    closed = true;
    if (timer) clearTimeout(timer);
    try { ws && ws.close(); } catch {}
  };
}
